/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseBroadcast } from '../../models/api-response-broadcast';
import { BroadcastUpload } from '../../models/broadcast-upload';

export interface CreateVoucherBroadcast$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: BroadcastUpload
}

export function createVoucherBroadcast(http: HttpClient, rootUrl: string, params: CreateVoucherBroadcast$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBroadcast>> {
  const rb = new RequestBuilder(rootUrl, createVoucherBroadcast.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseBroadcast>;
    })
  );
}

createVoucherBroadcast.PATH = '/v1/api/voucher';
